(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mm-delivery-card"] && !Shopify.designMode) return;
  try {
    (() => {
    function berlinDate(now) {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
      const value = (name) => Number(parts.find((part) => part.type === name).value);
      return new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
    }

    function easterSunday(year) {
      const a = year % 19;
      const b = Math.floor(year / 100);
      const c = year % 100;
      const d = Math.floor(b / 4);
      const e = b % 4;
      const f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4);
      const k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = (h + l - 7 * m + 114) % 31 + 1;
      return new Date(Date.UTC(year, month - 1, day));
    }

    function isWorkingDay(date, includeSaturday = false) {
      const weekday = date.getUTCDay();
      if (weekday === 0 || (weekday === 6 && !includeSaturday)) return false;
      const monthDay = `${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
      if (['1-1', '5-1', '10-3', '12-25', '12-26'].includes(monthDay)) return false;
      const easter = easterSunday(date.getUTCFullYear());
      const distance = Math.round((date.getTime() - easter.getTime()) / 86400000);
      return ![-2, 1, 39, 50].includes(distance);
    }

    function addWorkingDays(date, days, includeSaturday = false) {
      const result = new Date(date.getTime());
      let remaining = days;
      while (remaining > 0) {
        result.setUTCDate(result.getUTCDate() + 1);
        if (isWorkingDay(result, includeSaturday)) remaining -= 1;
      }
      return result;
    }

    function dateRange(first, last, locale, today) {
      const includeYear = first.getUTCFullYear() !== last.getUTCFullYear() || last.getUTCFullYear() !== today.getUTCFullYear();
      const format = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric', month: 'short', ...(includeYear ? { year: 'numeric' } : {}) });
      if (first.getTime() === last.getTime()) return format.format(first);
      return format.formatRange(first, last);
    }

    if (customElements.get('mm-delivery-timeline')) return;
    customElements.define('mm-delivery-timeline', class extends HTMLElement {
      connectedCallback() {
        this.updateDates();
        this.refresh = setInterval(() => this.updateDates(), 60000);
      }

      disconnectedCallback() {
        clearInterval(this.refresh);
      }

      updateDates() {
        if (this.dataset.country !== 'DE') return;
        const now = new Date();
        const today = berlinDate(now);
        const hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', hour: '2-digit', hourCycle: 'h23' }).format(now));
        const configuredCutoff = Number(this.dataset.productionCutoff ?? 21);
        const cutoff = Number.isFinite(configuredCutoff) ? Math.max(0, Math.min(23, configuredCutoff)) : 21;
        const sameDay = isWorkingDay(today) && hour < cutoff;
        const key = `${today.toISOString().slice(0, 10)}-${sameDay}`;
        if (this.currentDay === key) return;
        this.currentDay = key;
        const number = (name, fallback) => Math.max(1, Math.min(30, Number(this.dataset[name]) || fallback));
        const productionMin = number('productionMin', 1);
        const productionMax = Math.max(productionMin, number('productionMax', 1));
        const handoffMin = number('handoffMin', 1);
        const handoffMax = Math.max(handoffMin, number('handoffMax', 2));
        const transitMin = number('transitMin', 2);
        const transitMax = Math.max(transitMin, number('transitMax', 3));
        const productionBase = sameDay ? today : addWorkingDays(today, 1);
        const productionFirst = addWorkingDays(productionBase, productionMin - 1);
        const productionLast = addWorkingDays(productionBase, productionMax - 1);
        const dispatchFirst = addWorkingDays(productionFirst, handoffMin);
        const dispatchLast = addWorkingDays(productionLast, handoffMax);
        const arrivalFirst = addWorkingDays(dispatchFirst, transitMin, true);
        const arrivalLast = addWorkingDays(dispatchLast, transitMax, true);
        const locale = this.dataset.locale || 'de-DE';
        for (const [name, first, last] of [['production', productionFirst, productionLast], ['dispatch', dispatchFirst, dispatchLast], ['arrival', arrivalFirst, arrivalLast]]) {
          const value = dateRange(first, last, locale, today);
          const accessibleFormat = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', dateStyle: 'long' });
          this.querySelectorAll(`[data-mm-delivery-date="${name}"]`).forEach((element) => {
            element.textContent = value;
            element.title = `${accessibleFormat.format(first)} – ${accessibleFormat.format(last)}`;
          });
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
